import { useState, useEffect } from 'react';
import { OperatingHoursPage } from './seller/OperatingHoursPage';
import { DesktopOperatingHoursPage } from './desktop/DesktopOperatingHoursPage';

export function ResponsiveOperatingHoursPage() {
  const [isMobile, setIsMobile] = useState(true);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 1024);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  return isMobile ? <OperatingHoursPage /> : <DesktopOperatingHoursPage />;
}